angular.module('app').factory('resourcesService', [
    '$http',
    function ($http) {
        return {
            getResource: function(name){
                return $http({
                    method: 'GET',
                    url: './resources/' + name
                })
            }
        }
    }
]);